export default function SettingsIcon({
  width,
  height,
}: {
  width?: number;
  height?: string;
}) {
  return (
    <svg
      className="z-10"
      width={width ? width : "20"}
      height={height ? height : "21"}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_410_1034)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.2857 10.5C13.9075 10.5 13.2143 10.428 13.2143 10.316V20.5H15.3571V10.316C15.3571 10.428 14.6639 10.5 14.2857 10.5ZM15.3571 2.68402V0.5H13.2143V2.68402C12.1429 3.09702 11.0714 4.196 11.0714 5.5C11.0714 7.157 12.5104 8.5 14.2857 8.5C16.0611 8.5 17.5 7.157 17.5 5.5C17.5 4.196 16.4286 3.09702 15.3571 2.68402ZM6.78571 10.684V0.5H4.64286V10.684C4.97929 10.572 5.33607 10.5 5.71429 10.5C6.0925 10.5 6.78571 10.572 6.78571 10.684ZM8.92857 15.5C8.92857 16.804 7.85714 17.903 6.78571 18.316V20.5H4.64286V18.316C3.57143 17.903 2.5 16.804 2.5 15.5C2.5 13.843 3.93893 12.5 5.71429 12.5C7.48964 12.5 8.92857 13.843 8.92857 15.5Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_410_1034">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
